module.exports = __webpack_public_path__ + "static/media/20210409_194603_345_IMG_0080.cc25dff3.jpg";